import { Pipe, PipeTransform } from '@angular/core';
import { FundProductInterface, IProductDocument } from '@spa/api';
import { Product } from 'src/app/pages/portal/services';

import { LanguageService } from '../language.service';

@Pipe({
  name: 'productDocuments'
})
export class ProductDocumentsPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }

  transform(product?: FundProductInterface | Product): IProductDocument[] {
    if (!product) {
      return [];
    }

    return product.productDocuments
      ? product.productDocuments.filter(document => document.language === this.languageService.getCurrentLanguage())
      : [];
  }
}
